/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { PublicAlert } from './public-alert';

/**
 * 
 * @export
 * @interface ComponentState
 */
export interface ComponentState {
    /**
     * Значение лейбла группировки
     * @type {string}
     * @memberof ComponentState
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentState
     */
    'status': ComponentStateStatusEnum;
    /**
     * 
     * @type {Array<PublicAlert>}
     * @memberof ComponentState
     */
    'alerts': Array<PublicAlert>;
}

export const ComponentStateStatusEnum = {
    Operational: 'OPERATIONAL',
    Degraded: 'DEGRADED',
    Down: 'DOWN',
    Unknown: 'UNKNOWN'
} as const;

export type ComponentStateStatusEnum = typeof ComponentStateStatusEnum[keyof typeof ComponentStateStatusEnum];


